import { createSlotRecipe } from './runtime.js';

const chatThreadConfig = {"name":"chatThread","slots":["root","viewport","viewportFooter"]}

export const chatThread = /* @__PURE__ */ createSlotRecipe(chatThreadConfig)